import React, { FC } from 'react';
import grid from '@/common/css/grid.module.scss';
import { PopupsBlockProps } from '@/pages/CareersPage/CareersPage.types';
import PopupCard from '@/pages/CareersPage/components/PopupCard/PopupCard';
import key from 'weak-key';

const PopupsBlock: FC<PopupsBlockProps> = ({ popups }) => {
  const renderCards = () => {
    if (!popups || !popups.length) {
      return null;
    }

    return popups.map((popup) => <PopupCard key={key(popup)} {...popup} />);
  };

  return (
    <div className={grid.row}>{renderCards()}</div>
  );
};
PopupsBlock.displayName = 'PopupsBlock';

export default PopupsBlock;
